import {UPDATE_GIFT_OPTIONS} from './constants';

export const toggleOption = (giftingOptions, optionToToggle, value, shouldShowGifting = null) => {
  const {options, showGifting} = giftingOptions;
  // TODO: move giftingOptions stuff to the reducer
  return {
    type: UPDATE_GIFT_OPTIONS,
    payload: {
      showGifting: shouldShowGifting || showGifting,
      options: {
        ...options,
        [optionToToggle]: value,
      },
    },
  };
};
